import { createFileRoute } from '@tanstack/react-router';
import { DocumentDetail } from '@/features/vault/components/DocumentDetail';

/**
 * Index route for /vault/document/$ref — renders DocumentDetail.
 *
 * This is a child of the transparent layout in vault_.document.$ref.tsx.
 * Keeping DocumentDetail here (rather than in the parent) is required so
 * that sibling routes (/edit, /review) can render as full-page replacements
 * instead of being nested inside DocumentDetail's JSX.
 */
export const Route = createFileRoute('/vault_/document/$ref/')({
  component: DocumentDetail,
});
